import React from 'react'
import { Outlet, useOutletContext } from 'react-router'
import { Footer } from '#app/components/footer'
import { Header } from '#app/components/header.tsx'
import { type Theme } from '#app/utils/theme.server.ts'

export default function RootLayout() {
	const { theme } = useOutletContext<{ theme: Theme }>()

	return (
		<div className="min-h-screen p-2 md:p-4 lg:p-8">
			<Header className="pb-2 md:pb-4 lg:pb-8" userPreference={theme} />

			<div className="mb-2 flex flex-col">
				<Outlet />
			</div>
			<hr />
			<Footer className="pt-2 md:pt-4 lg:pt-8" />
		</div>
	)
}
